<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <v-card
                :loading="loading"
        >
            <v-card-title>
                Reviews List
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="desserts"
                    :search="search"
                    class="elevation-1"
                    sort-by.sync="id"
                    sort-desc.sync="true"
            >
                <template v-slot:item.status="{ item }">
                    <span v-if="item.status == 1">Visible</span>
                    <span v-else-if="item.status == 0">Pending</span>
                    <span v-else-if="item.status == 2">Hidden</span>
                </template>
                <template v-slot:item.edit="{ item }">
                    <v-btn icon :to="'/review/'+item.id">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-icon
                            small
                            @click="deleteItem(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                loading:true,
                search: '',
                headers: [
                    {
                        text: 'ID',
                        align: 'left',
                        value: 'id',
                    },
                    { text: 'Date', value: 'date' },
                    { text: 'House', value: 'house' },
                    { text: 'Customer', value: 'name' },
                    { text: 'Rate', value: 'rate' },
                    { text: 'Status', value: 'status' },
                    {
                        text: 'Edit',
                        value: 'edit' ,
                        align: 'right',
                        sortable: false,
                    },
                ],
                desserts: [],
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Houses',
                        disabled: false,
                        to: '/house',
                    },
                    {
                        text: 'Revies List',
                        disabled: true,
                        to: '/reviews',
                    },
                ],

            }
        },
        methods: {
            deleteItem (item) {
                var a = confirm('Are you sure you want to delete this item? This action cannot be undone');
                if(a){
                    this.loading = true;
                    this.$http.get("https://api.bestchoicevacation.com/reviews/delete/"+item.id,{
                        headers: {
                            'x-access-token': localStorage.hash
                        }
                    }).then(response =>{
                        console.log(response.data);
                        this.pingPage();
                    });
                }
            },
            pingPage(){
                this.$http.get("https://api.bestchoicevacation.com/reviews/list",{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.desserts = [];
                    this.loading = false;
                    for(let i = 0;i<response.data.length;++i){
                        this.desserts.push({
                            id:response.data[i].id,
                            date:response.data[i].date,
                            house:response.data[i].house,
                            name:response.data[i].name,
                            status:response.data[i].status,
                            rate:response.data[i].rate
                        });
                    }
                });
            }
        },
        mounted(){
            this.pingPage();
        }
    }
</script>
